/**
 * Single source of truth for which version of each legal document is
 * currently in effect — stamped onto any consent record (waiver signature,
 * guest booking consent) and shown as the effective date on the policy
 * pages themselves. Bump whenever the corresponding page's substantive
 * content changes.
 */
export const PRIVACY_POLICY_VERSION = '2026-08-26'
export const TERMS_VERSION = '2026-08-26'
export const LIABILITY_WAIVER_VERSION = '2026-07-29'
